<template lang="pug">
    
    .types.block.block--white

        .row.row--two-col
            .column.animate-apear.animate-apear--left(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                Heading(
                    tag='h2'
                    :text='data.heading'
                    color='blue'
                    )
                
                p(v-html='data.paragraph[0]')

            .column.column--pr0.types__svg
                svg
                    use(xlink:href='#quarantine-svg')

        SelectorRich(:data='data.selectorbig')

        .row
            .column.column--mb0.types__selector-desc
                p(v-html='data.selectorsmall.heading')

        SelectorSmall(:data='data.selectorsmall')


</template>

<script>
import Heading from '@/components/utility/Heading.vue';

export default {
    name: 'Types',

    components: {
        Heading,
        SelectorRich: () => import('@/components/utility/SelectorRich.vue'),
        SelectorSmall: () => import('@/components/utility/SelectorSmall.vue')
    },

    props: {
        data: Object
    },

    methods: {
        blockVisibilityChanged(isVisible, el) {
            if (isVisible) el.target.classList.add('show');
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';

.types {
    position: relative;

    &__selector-desc {
        text-align: center;

        p {
            display: inline-block;
            max-width: 35vw;
            text-align: center;

            @media (--viewport-mobile) {
                max-width: 100%;
            }
        }
    }

    &__svg {
        text-align: right;

        @media (--viewport-mobile) {
            display: none;
        }

        svg {
            width: 30vw;
            height: calc(30vw * (537 / 494));
            margin-right: 5vw;
        }
    }
}
</style>
